import React, { useMemo } from "react";

import { IconButton, Stack } from "@mui/material";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

import useStyles from "./styles";
import { Button } from "../Form";

interface Props {
  page: number;
  total: number;
  pageSize: number;
  onChangePage: (page: number) => void;
}

const Paginate = (props: Props) => {
  const { page, total, pageSize, onChangePage } = props;

  const { t: translate } = useTranslation();

  const classes = useStyles();

  const totalPages = useMemo(() => {
    if (Number.isInteger(total / pageSize)) {
      return total / pageSize;
    }

    return parseInt((total / pageSize).toString()) + 1;
  }, [total, pageSize]);

  return (
    <Stack direction="row" width="100%" alignItems="center" justifyContent="space-between">
      <Stack>
        <span className={classes.textFooterShowInfo}>
          {translate("showing")} {(page - 1) * pageSize + 1} -{" "}
          {pageSize * page > total ? total : pageSize * page} {translate("of")}{" "}
          {total.toLocaleString("pt-BR")}
        </span>
      </Stack>
      <Stack direction="row">
        <IconButton
          size="small"
          disabled={page === 1}
          className={classnames(classes.buttonPage, classes.buttonPageFirst)}
          onClick={() => onChangePage(page - 1)}
        >
          <IoIosArrowBack size={20} color={page === 1 ? "#E4E7EC" : "#667085"} />
        </IconButton>
        {page !== 1 && page - 1 !== 1 && (
          <Button className={classes.buttonPage} onClick={() => onChangePage(1)}>
            1
          </Button>
        )}
        {page !== 1 && page - 1 !== 1 && (
          <Button disabled className={classes.buttonPage}>
            ...
          </Button>
        )}

        {page - 1 > 0 && (
          <Button className={classes.buttonPage} onClick={() => onChangePage(page - 1)}>
            {page - 1}
          </Button>
        )}

        {page <= totalPages && (
          <Button className={classnames(classes.buttonPage, classes.buttonSelected)}>{page}</Button>
        )}

        {page + 1 <= totalPages && (
          <Button className={classes.buttonPage} onClick={() => onChangePage(page + 1)}>
            {page + 1}
          </Button>
        )}

        {page !== totalPages && page + 1 !== totalPages && (
          <Button disabled className={classes.buttonPage}>
            ...
          </Button>
        )}
        {page !== totalPages && page + 1 !== totalPages && (
          <Button className={classes.buttonPage} onClick={() => onChangePage(totalPages)}>
            {totalPages}
          </Button>
        )}
        <IconButton
          size="small"
          disabled={page === totalPages}
          className={classnames(classes.buttonPage, classes.buttonPageNext)}
          onClick={() => onChangePage(page + 1)}
        >
          <IoIosArrowForward size={20} color={page === totalPages ? "#E4E7EC" : "#667085"} />
        </IconButton>
      </Stack>
    </Stack>
  );
};

export default Paginate;
